import { exponentialBackoff, whitelist } from '@fluidx/utilities';
/**
 * The current cache version that is being used to store `EcsResponse` objects in `LocalStorage`
 * Whenever we change the `EcsResponse` interface or we want to change what we store in cache,
 * we should bump this version to clean previous cached `EcsResponse`
 */
export const cacheVersion = 2;
/**
 * Object representing the ECS request retry policy.
 */
export const ecsClientRetryPolicy = {
    maxRetries: 3,
    filter: whitelist([429, 500, 503]),
    backoffFn: exponentialBackoff(500 /* initialRetryIntervalMs */)
};
/**
 * Regex pattern to validate guestAgents from ecsClientConfiguration
 */
export const guestAgentPattern = /.+\S\([^\(\)]+\)$/;
/**
 * Different ECS Endpoints
 * Visit <https://skype.visualstudio.com/SKYPECENTRAL/_wiki/wikis/SKYPECENTRAL.wiki/149/ECS-Onboarding> for more information about ECS endpoints
 */
export var EcsEndpoint;
(function (EcsEndpoint) {
    /**
     * US Department of Defense endpoint
     */
    EcsEndpoint["DOD"] = "https://config.ecs.dod.teams.microsoft.us";
    /**
     * GCCHigh endpoint
     */
    EcsEndpoint["GCCHigh"] = "https://config.ecs.gov.teams.microsoft.us";
    /**
     * GCC endpoint
     */
    EcsEndpoint["GCC"] = "https://ecs.office.com";
    /**
     * Public endpoint
     */
    EcsEndpoint["PUBLIC"] = "https://ecs.office.com";
})(EcsEndpoint || (EcsEndpoint = {}));
//# sourceMappingURL=EcsClientConstants.js.map